import React, {Component, useState, useEffect} from 'react';
import {connect} from 'react-redux';

const BookForumMakeContainer = (props) => {

  const [isLoaded, setIsLoaded] = useState(false)
  const [state, setState] = useState({})

  useEffect(() => {

  })

  return (
    <div>
      BookForumMakeContainer

    </div>
  )
}

const enhance = connect(
  state => ({
    ...state
  }),
  {}
);

export default enhance(BookForumMakeContainer);
